import store from "../store";
import { ROUTE_PATHS } from "./RoutesPaths";

export const PERMISSIONS_IDS = {
  // products module
  product_request_view: 1,
  product_request_accept_reject: 2,
  product_view: 3,
  // categories module
  category_view: 4,
  category_add: 5,
  category_edit: 6,
  category_delete: 7,
  category_request_view: 8,
  category_request_accept_reject: 9,
  // sub categories module
  sub_category_view: 10,
  sub_category_add: 11,
  sub_category_edit: 12,
  sub_category_delete: 13,
  // users module
  users_exporter_view: 14,
  users_importer_view: 15,
  // verifications module
  verification_request_offplatform_view: 16,
  verification_request_online_view: 17,
  verification_request_banktransfer_view: 18,
  verification_request_offplatform_initial_accept_reject: 19,
  verification_request_offplatform_final_accept_reject: 20,
  verification_request_online_final_accept_reject: 21,
  verification_request_banktransfer_final_accept_reject: 22,
  // vouchers module
  vouchers_view: 23,
  vouchers_generate: 24,
  // roles module
  roles_view: 27,
  roles_add: 25,
  roles_edit: 26,
  roles_delete: 28,
  // employees module
  employees_view: 31,
  employees_add: 29,
  employees_edit: 30,
  employees_activate_deactivate: 32,
  // transactions module
  transactions_view: 33
};

export const getInitialRoute = () => {
  const Permissions = store.getState()?.auth?.login?.Permissions;
  let path = ROUTE_PATHS.login;
  Permissions?.some((permission) => {
    switch (permission) {
      case PERMISSIONS_IDS.product_request_view:
        path = ROUTE_PATHS.productsRequests;
        return true;
      case PERMISSIONS_IDS.product_view:
        path = ROUTE_PATHS.approvedProducts;
        return true;
      case PERMISSIONS_IDS.category_view:
        path = ROUTE_PATHS.approvedCategories;
        return true;
      case PERMISSIONS_IDS.category_request_view:
        path = ROUTE_PATHS.categoriesRequests;
        return true;
      case PERMISSIONS_IDS.sub_category_view:
        path = ROUTE_PATHS.subCategories;
        return true;
      case PERMISSIONS_IDS.users_exporter_view:
        path = ROUTE_PATHS.usersExporters;
        return true;
      case PERMISSIONS_IDS.users_importer_view:
        path = ROUTE_PATHS.usersImporters;
        return true;
      case PERMISSIONS_IDS.verification_request_offplatform_view:
      case PERMISSIONS_IDS.verification_request_online_view:
      case PERMISSIONS_IDS.verification_request_banktransfer_view:
        path = ROUTE_PATHS.verificationRequests;
        return true;
      case PERMISSIONS_IDS.vouchers_view:
        path = ROUTE_PATHS.vouchers;
        return true;
      case PERMISSIONS_IDS.roles_view:
        path = ROUTE_PATHS.roles;
        return true;
      case PERMISSIONS_IDS.employees_view:
        path = ROUTE_PATHS.employeesList;
        return true;
      case PERMISSIONS_IDS.transactions_view:
        path = ROUTE_PATHS.transactions;
        return true;
      default:
        return false;
    }
  });
  return path;
};

export const isSuperAdmin = () => {
  const IsSuperAdmin = store.getState().auth.login?.IsSuperAdmin;
  return IsSuperAdmin;
};

export const hasPermission = (permissionId) => {
  const Permissions = store.getState().auth.login?.Permissions;
  return isSuperAdmin() || Permissions?.includes(permissionId);
};
